export abstract class AbstractContractItemViewModel {
    public cid: string;
    public offerName: string;
    public detail: string;
}
